import * as React from "react";

const SelectIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="24"
    fill="none"
    viewBox="0 0 23 16"
  >
    <path
      fill="#2c2c2c"
      d="M6 15h16c.55 0 1-.525 1-1.167 0-.641-.45-1.166-1-1.166H6c-.55 0-1 .525-1 1.166C5 14.475 5.45 15 6 15m0-5.833h16c.55 0 1-.525 1-1.167s-.45-1.167-1-1.167H6c-.55 0-1 .525-1 1.167s.45 1.167 1 1.167m-1-7c0 .641.45 1.166 1 1.166h16c.55 0 1-.525 1-1.166C23 1.525 22.55 1 22 1H6c-.55 0-1 .525-1 1.167M4 2c0-1.1-.9-2-2-2S0 .9 0 2s.9 2 2 2 2-.9 2-2m0 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2m0-6c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2"
    ></path>
  </svg>
);

export default SelectIcon;
